import type { ElementOrdering } from "@/lib/stores/canvas-store/canvas-layer-order";

export const IS_MAC = navigator.userAgent.includes("Mac");

// code is the physical key (event.code), since Option changes the typed character on Mac.
export type Shortcut = {
  code: string;
  label: string;
  mod?: boolean;
  alt?: boolean;
  shift?: boolean;
};

export function getShortcutLabel({ label, mod, alt, shift }: Shortcut) {
  if (IS_MAC) {
    return `${alt ? "⌥" : ""}${shift ? "⇧" : ""}${mod ? "⌘" : ""}${label}`;
  }

  return [mod && "Ctrl", alt && "Alt", shift && "Shift", label]
    .filter(Boolean)
    .join("+");
}

export function matchesShortcut(
  event: KeyboardEvent,
  { code, mod = false, alt = false, shift = false }: Shortcut,
) {
  return (
    event.code === code &&
    (event.metaKey || event.ctrlKey) === mod &&
    event.altKey === alt &&
    event.shiftKey === shift
  );
}

// Figma's: Option on Mac, Shift elsewhere (Ctrl+Alt is AltGr on many keyboards).
const toEnd = IS_MAC ? { alt: true } : { shift: true };

export const ORDERING_SHORTCUTS: Record<ElementOrdering, Shortcut> = {
  "bring-to-front": { code: "BracketRight", label: "]", mod: true, ...toEnd },
  "bring-forward": { code: "BracketRight", label: "]", mod: true },
  "send-backward": { code: "BracketLeft", label: "[", mod: true },
  "send-to-back": { code: "BracketLeft", label: "[", mod: true, ...toEnd },
};
